import axios from "axios";
import { config } from "config";
import { T_Activity } from "types";

export const recordActivity = async (data: {
  data: T_Activity;
  ipAddress?: string;
}) => {
  try {
    const response = await axios.post(
      `${config.apiUrl}/api/record-activity`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUserFromPodcast = async (token: string) => {
  try {
    const response = await axios.get(
      `${config.apiUrl}/api/get-user-id-from-podcast/${token}`,
    );
    return response.data as string;
  } catch (error) {
    console.error(error);
  }
};
